export const getPolicyEndpoints = (
  loyaltyLocationCode = '',
  redirectParam = '',
  isAppUser = false,
  hasChangedEmail = false,
  hasChangedPassword = false
) => {
  let policyEndpoint = ''
  let clientId = ''
  let redirectUrl = ''

  const accountLink = loyaltyLocationCode == 'DE' ? '/konto' : '/konto-at'
  const changeLoginData = hasChangedEmail || hasChangedPassword
  const successParam = hasChangedPassword ? 'passwordChange=true' : ''
  const appParam = isAppUser ? 'device=APP' : ''

  const finalAccountRedirect =
    isAppUser && !changeLoginData
      ? `${accountLink}?${appParam}`
      : changeLoginData && !isAppUser
        ? `${accountLink}${successParam ? `?${successParam}` : ''}`
        : isAppUser && changeLoginData
          ? `${accountLink}?${appParam}${successParam ? `&${successParam}` : ''}`
          : null

  const stageUrl =
    loyaltyLocationCode == 'DE'
      ? 'https://new.biomarkt.de'
      : 'https://new.denns-biomarkt.at'

  const prodUrl =
    loyaltyLocationCode == 'DE'
      ? 'https://www.biomarkt.de'
      : 'https://www.denns-biomarkt.at'

  switch (process.env.GATSBY_NODE_ENV) {
    case 'development':
      policyEndpoint = 'b2cltytstwe'
      clientId = '5ea93b85-59ea-47c8-a8e9-db7657e0c151'
      redirectUrl =
        !isAppUser && !changeLoginData
          ? `/profil${redirectParam}`
          : finalAccountRedirect
      break
    case 'stage':
      policyEndpoint = 'b2cltytstwe'
      clientId = '5ea93b85-59ea-47c8-a8e9-db7657e0c151'
      redirectUrl =
        !isAppUser && !changeLoginData
          ? `${stageUrl}/profil${redirectParam}`
          : `${stageUrl}${finalAccountRedirect}`

      break
    case 'production':
      policyEndpoint = 'b2cltyprdwe'
      clientId = '475b1c94-8723-4201-bb0f-41156df28ad9'
      redirectUrl =
        !isAppUser && !changeLoginData
          ? `${prodUrl}/profil${redirectParam}`
          : `${prodUrl}${finalAccountRedirect}`
      break

    default:
      return null
  }
  return { policyEndpoint, clientId, redirectUrl }
}
